export default __webpack_public_path__ + "static/media/logo-shopify.8e3e9302.svg";